// extracted by mini-css-extract-plugin
export var divider = "_nw-0";
export var systemMessage = "_nw-1";